<template>
  <!-- 文件包 -->
  <div
    class="id_10"
    v-loading="loading"
    element-loading-text="正在下载，可能需要几分钟，请耐心等待…"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- 批量下载 -->
    <div class="download" v-show="list.length>1">
      <span class="cursor" @click="allDownload">批量打包下载</span>
    </div>

    <!-- 这个文件显示大盒子 -->
    <div class="file_box">
      <!-- 文件列表 -->
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="item_box cursor" @click="download(item)">
          <div class="img">
            <img :src="imgType[$utils.fileFormat(item.fileName)]">
          </div>
          <!-- 文件名 -->
          <p :title="item.fileName">{{item.fileName}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'

export default {
  props: {
    data: Object
  },
  name: 'id_10',
  data () {
    return {
      loading: false,
      imgType: {
        excel: 'https://img.webloom.cn/img/e9f3578a5662d88d06212e1a679a6c69.png',
        pdf: 'https://img.webloom.cn/img/6e589e04bc01031799d4c74e896b1d2b.png',
        ppt: 'https://img.webloom.cn/img/c4b25533e6e5d3136f3eeaf90a92490f.png',
        word: 'https://img.webloom.cn/img/cf437ddded0d507c378efd1cd26dcc3b.png',
        video: 'https://img.webloom.cn/img/01e2ade2b02657a0a02787014456849c.png',
        unknown: 'https://img.webloom.cn/img/66b857c8d831c850076d8786b20fc46f.png',
        zip: 'https://img.webloom.cn/img/5d64b3a820e5176b744f96a66603cf32.png',
        music: 'https://img.webloom.cn/img/fb69865ed25bdc8b1152acd7128da2ec.png',
        img: 'https://img.webloom.cn/img/76d8a31db631822f3ebda8af01e86ca0.png'
      },
      // list: [{fileName: '193f194be66e60e00e3949e5451b2cf4.zip', fileUrl: 'http://133.13.13.125/bloom_web/123321.zip'}, {fileName: '获奖名单格式.xlsx', fileUrl: 'http://133.13.13.125/bloom_web/321123.xlsx'}]
      list: []
    }
  },
  methods: {
    // 打包下载
    allDownload () {
      const self = this
      this.loading = true
      async function abc () {
        const data = self.list
        const zip = new JSZip()
        const cache = {}
        const promises = []
        await data.forEach((item, key) => {
          const promise = self.getFile(item.fileUrl).then(dta => { // 下载文件, 并存成ArrayBuffer对象
            zip.file(item.fileName, dta.data, {binary: true}) // 逐个添加文件
            cache[item.fileName] = dta
          })
          promises.push(promise)
        })
        Promise.all(promises).then(() => {
          zip.generateAsync({type: 'blob'}).then(content => {              // 生成二进制流
            FileSaver.saveAs(content, 'bloom课程文件.zip')                  // 利用file-saver保存文件
            self.loading = false
          }).catch(err => {
            console.log(err)
            self.loading = false
            this.$message.error(self.$t('flowCertificate11'))
          })
        })
      }
      abc()
    },
    // 下载文件
    getFile (url) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error.toString())
        })
      })
    },
    // 单个下载
    download (data) {
      window.open(data.fileUrl)
    },
    // 初始化
    init () {
      if (this.data.list) {
        let arr = JSON.parse(this.data.list) || []
        this.list = arr
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.id_10{
  padding-top: 24px;
  border-radius: 4px;
  word-wrap:break-word;
  .download{
    span{
      color: #2b6fff;
      text-decoration: underline;
    }
  }
  .file_box{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 33.3333%;
      padding: 16px;
      box-sizing: border-box;
      .item_box{
        z-index: 0;
        .img{
          font-size: 0px;
          line-height: 0;
          padding: 16px 32px 32px 32px;
          img{
            width: 100%;
          }
        }
        p{
          width: 100%;
          text-align: center;
          margin-top: -16px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_10.vue